import Box from '@components/Box';
import PlacingOrderTitle from './PlacingOrderTitle';
import TextInputContainer from '@containers/TextInputContainer';
import { Column, Row } from '@components/Grid';
import { IPlacingOrderContactsProps } from '../types';
import { useTranslation } from 'react-i18next';
import { Text, TextColor, TextSize, TextType } from '@components/Text';

const PlacingOrderContacts: React.FC<IPlacingOrderContactsProps> = (props: IPlacingOrderContactsProps): React.ReactElement => {
  const {
    contactHint,
    contactMinLength,
    contactPlaceholder,
    control,
    country,
    showEmail
  } = props;

  const { t } = useTranslation();

  return (
      <>
        <PlacingOrderTitle title={t('placingOrderModalWindow.form.contacts.title')}/>
        <Row>
          <Column phone={12}>
            <Box mb={contactHint ? 3 : 5}>
              <TextInputContainer
                  control={control}
                  name="fullName"
                  rules={{
                    validate: (value) => {
                      if (typeof value !== 'string') return true;
                      return !contactMinLength || value.trim().length >= contactMinLength || t('placingOrderModalWindow.form.contacts.error');
                    }
                  }}
                  title={contactPlaceholder}
              />
            </Box>
          </Column>
        </Row>
        {contactHint && (
            <Row>
              <Column phone={12}>
                <Box mb={5}>
                  <Text
                      color={TextColor.DARK_MUTED}
                      size={TextSize.S}
                      type={TextType.SPAN}
                  >
                    {contactHint}
                  </Text>
                </Box>
              </Column>
            </Row>
        )}
        <Row>
          <Column phone={6}>
            <Box
                mb={5}
                pr={4}
            >
              <TextInputContainer
                  control={control}
                  name="phone"
                  onlyCountry={country}
                  title={t('placingOrderModalWindow.form.contacts.phone')}
                  type="phone"
              />
            </Box>
          </Column>
          {showEmail && (
              <Column phone={6}>
                <Box mb={5}>
                  <TextInputContainer
                      control={control}
                      name="email"
                      title="Email"
                      type="email"
                  />
                </Box>
              </Column>
          )}
        </Row>
      </>
  );
};

export default PlacingOrderContacts;